// analytics request the pack type for Pack and RePack, but the subType for Chart
export enum PackAnalyticsType {
    Chart = 'Chart',
    Creator = 'Creator',
    Pack = 'Pack',
    RePack = 'Repack',
}

